import React from 'react';
import { Switch } from 'antd';

export const LCSwitch = props => <Switch {...props} />;
